require('./brokerConsultMiFIDView.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { Component } = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerConsultMiFIDItem = require('mifid/components/brokerConsultMiFIDItem/brokerConsultMiFIDItem')

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { formatDate } = require('utilities/dateHelper');

// @actions
const BrokerConsultMiFIDActions = require('mifid/actions/brokerConsultMiFID');
// @constants
const {
    MYPROFILE_BROKER_URL,
    DATE_FORMAT_SLASHED_ES,
    DATETIME_FORMAT_ES
} = require('constants/index');
const { HISTORY_TYPE_TEST } = require("mifid/constants/constants");

// @ utils
const {
    buildItems,
} = require('mifid/utilities/mifidTestTextHelper');

class BrokerConsultMiFIDView extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchConsultResultMiFID(this.props.history);
    }

    buildRightContent() {
        const { immBrokerConsulResultMiFID } = this.props;
        if (!immBrokerConsulResultMiFID.get('fetching')) {
            return (
                <div>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidRightContentWithTest1" />
                    </p>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidRightContentWithTest2" />
                    </p>
                </div>
            )
        }
    }

    buildLeftContent() {
        const { immBrokerConsulResultMiFID } = this.props;
        const listOfTest = immBrokerConsulResultMiFID.get('tests').toJS();
        const items = listOfTest.length > 0 ? buildItems(listOfTest) : buildItems(HISTORY_TYPE_TEST);
        let content;
        if(items) {
            content = items.map((item, index) => {
                const rawDate = item.DATE
                const date = !!rawDate && rawDate !== '-'
                ? formatDate(moment(rawDate, DATE_FORMAT_SLASHED_ES), DATETIME_FORMAT_ES)
                : '-'
                return (
                    <BrokerConsultMiFIDItem
                        items={[item.DESCRIPTION_TEST, item.STATUS, date]}
                        key={index}
                    />
                )
            })
        }

        return (
            <div>
                <div>
                    <strong>
                        <FormattedText value="broker-brokerConsultMifidContentDescription" />
                    </strong>
                    <BrokerConsultMiFIDItem
                        items={[
                            formatText('broker-brokerConsultMifidContentTableHeader_investmentProduct'),
                            formatText('broker-brokerConsultMifidContentTableHeader_testResult'),
                            formatText('broker-brokerConsultMifidContentTableHeader_date')
                        ]}
                        isHeader={true}
                    />
                    {content}
                </div>
                <div className="consult-result-mifid-view__container--footer-text">
                    <p>
                        <FormattedText value="broker-brokerConsultMifidContentFooter1" />
                    </p>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidContentFooter2" />
                    </p>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidContentFooter3" />
                    </p>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidContentFooter4" />
                    </p>
                    <p>
                        <FormattedText value="broker-brokerConsultMifidContentFooter5" />
                    </p>
                </div>
                <div className="consult-result-mifid-view__container--footer-link">
                    <OKLink modifier="emphasize" to={MYPROFILE_BROKER_URL}>
                        <FormattedText value="broker-brokerConsultMifidGoToInvestmentLink" />
                    </OKLink>
                </div>
            </div>
        )
    }

    buildContent() {
        const { immBrokerConsulResultMiFID } = this.props;
        const fetchContent = immBrokerConsulResultMiFID.get('fetching');
        let content;
        if (!fetchContent) {
            content = (
                <div className="consult-result-mifid-view__container">
                    <div className="consult-result-mifid-view__container--left-content">
                        <OKSectionBox title={formatText('consultMiFID-investorEvaluation')} hasShadow={false}>
                            <p className="consult-result-mifid-view__container-subtitle">
                                <FormattedText value="broker-brokerConsultMifidContentSubtitle" />
                            </p>
                            {this.buildLeftContent()}
                        </OKSectionBox>
                    </div>
                    <div className="consult-result-mifid-view__container--right-content">
                        {this.buildRightContent()}
                    </div>
                </div>
            )
        } else {
            content = (
                <LoadingSection />
            )
        }

        return content;
    }

    render() {

        return (
            <div>
                <div className="container-fluid consult-mifid-view--header-identifier">
                    <div className="row">
                        <OKCover size="medium" section="broker" customClass="col-xs-12">
                            <OKHeaderLanding title={formatText("consultMiFID-title")} />
                        </OKCover>
                    </div>
                </div>
                <div className="consult-result-mifid-view__body">
                    <div className="container-fluid">
                        {this.buildContent()}
                    </div>
                </div>
            </div>
        );
    }
}

BrokerConsultMiFIDView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immBrokerConsulResultMiFID: PropTypes.object.isRequired,
    immBrokerConsultMiFID: PropTypes.object.isRequired,
    fetchConsultResultMiFID: PropTypes.func.isRequired,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    onConsultMiFIDTest: PropTypes.func.isRequired
};

module.exports.constructor = BrokerConsultMiFIDView;
module.exports.BrokerConsultMiFIDView = connect(
    state => ({
        immBrokerConsulResultMiFID: state.brokerConsultMiFID,
        immProfileFields: state.profile
    }),
    {
        fetchConsultResultMiFID: BrokerConsultMiFIDActions.consultResultMiFID,
    }
)(withRouter(BrokerConsultMiFIDView));
